import { useTranslation } from 'react-i18next';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { IBenefit } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import {
  benefitIconMapper,
  benefitOptionsMapper,
  getBenefitExemptionsSlugs,
  getBenefitMethods,
} from '@/common/utils/benefits/benefit-utils';
import { CardBenefit } from '@coverflex-tech/hypernova';
import { Href } from 'expo-router';
import { useCustomProps } from './utils';

interface IProps {
  benefit: IBenefit<IMenhirBenefitSlug>;
}

export const BenefitCard = ({ benefit }: IProps) => {
  const { t } = useTranslation();

  const options = benefitOptionsMapper[benefit.slug];
  const usageMethods = getBenefitMethods(benefit);
  const exemptions = getBenefitExemptionsSlugs(benefit);
  const customProps = useCustomProps(benefit);
  const cardIcon = benefitIconMapper[benefit.slug];

  if (!options || !cardIcon) {
    return null;
  }

  return (
    <RouterLink href={options.route as Href} aria-label={t(options.label)}>
      {
        <CardBenefit
          variant="employee"
          icon={benefitIconMapper[benefit.slug]}
          title={t(options.label)}
          description={
            customProps?.description
              ? [customProps.description]
              : (exemptions.map((exemption) =>
                  t(`dashboard.benefits.exemptions.${exemption}`)
                ) as string[])
          }
          usage={usageMethods}
        />
      }
    </RouterLink>
  );
};
